import { NgModule } from '@angular/core';
import { Routes,
     RouterModule } from '@angular/router';

import { LegacyLoginComponent } from './legacy-login.component';

const routes: Routes = [
  {
    path: '',
    component: LegacyLoginComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LegacyLoginRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/components/legacy-login/legacy-login-routing.module.ts